import form_module_default from "./form.module.js";
import classNames from "classnames";
import { forwardRef } from "react";
import { jsx, jsxs } from "react/jsx-runtime";
import { Field } from "@radix-ui/react-form";
//#region src/components/Form/InlineField.tsx
var InlineField = forwardRef(function InlineField({ className, control, children, ...props }, ref) {
	const classes = classNames(form_module_default["inline-field"], className);
	return /* @__PURE__ */ jsxs(Field, {
		ref,
		...props,
		className: classes,
		children: [/* @__PURE__ */ jsx("div", {
			className: form_module_default["inline-field-control"],
			children: control
		}), /* @__PURE__ */ jsx("div", {
			className: form_module_default["inline-field-body"],
			children
		})]
	});
});
//#endregion
export { InlineField };

//# sourceMappingURL=InlineField.js.map